import udemy from '../assets/udemy.png';
import agile from '../assets/agile.png';
import cybersec from '../assets/cybersec.png';
import cybersec2 from '../assets/cybersec2.png';
import networksec from '../assets/networksec.png';
import agile2 from '../assets/agile2.png';
import datascience from '../assets/datascience.png';
import ai from '../assets/ai.png';
import comphard from '../assets/comphard.png';
import iot from '../assets/iot.png';
import genai from '../assets/genai.png';
import marketing from '../assets/marketing.png';
import marketing2 from '../assets/marketing2.png';
import nlp from '../assets/nlp.png';
import datasci from '../assets/datasci.png';
import cprog from '../assets/cprog.png';
import webdev from '../assets/webdev.png';
import aws from '../assets/aws.jpeg';
import app from '../assets/app.jpeg';
import html from '../assets/html.jpeg';
import css from '../assets/css.jpeg';
import datascifoun from '../assets/datascifoun.jpeg';
import html2 from '../assets/html2.jpeg'
import digimark from '../assets/digimark.jpeg'



export const portfolioData = {
  hero: {
    name: "Eshban Oliver",
    designation: "Web Developer",
    intro: "Welcome to my portfolio website! I'm a passionate and aspiring Front-End Developer with a strong desire to create innovative solutions and push the boundaries of technology.With a deep love for coding and problem-solving, I am constantly seeking opportunities to learn and grow in this ever-evolving field.",

  },
  about: {
    title: "About Me",
    des: `❃ Hi there, I'm Eshban Oliver 👋

I'm a passionate Front-end Developer 💻 with a keen interest in React Native 📱. I'm always eager to learn 🚀 and explore new technologies, and I'm excited to share my projects and contributions with you.
 About Me

 ● Currently Working As: Front-end Developer 👨‍💻
    Interests: React Native ⚛️, JavaScript 📜, HTML 🏷️, CSS 🎨, Modern Web Development 🌐, UI/UX Design 🖌️.
    Learning Focus: Deepening my React Native skills and exploring cross-platform mobile development 📱➡️🖥️.
    Philosophy: I believe in writing clean, maintainable code 🧼 and creating user-friendly interfaces 😊.
    Goal: To build innovative 💡 and impactful applications 🚀 that solve real-world problems 🌍.

● What You'll Find Here

    React Native Projects: Expect to see projects demonstrating my growing expertise in React Native ⚛️📱.
    Front-end Experiments: Explorations of modern web technologies 🌐 and UI/UX concepts 🎨.
    Contributions: Potential contributions to open-source projects 🤝.
    Learning Journey: Documentation of my progress 📈 and insights as I learn React Native 📚.

● Technologies I Work With

    Languages: JavaScript 📜, HTML 🏷️, CSS 🎨
    Tools: GitHub 🌳, VS Code 💻

● Let's Connect!

I'm always open to connecting with fellow developers 🤝 and enthusiasts 🎉. Feel free to reach out!

    Email: eshbanofficial@gmail.com 📧
    Portfolio: https://eshban.netlify.app/ 🌐

● Contributions and Collaboration

I'm interested in collaborating on exciting projects 🤝 related to React Native ⚛️📱 and front-end development 💻. If you have any opportunities or ideas, please don't hesitate to contact me.
Future Plans

    Continue to expand my knowledge of React Native 🚀 and build more complex applications 🏗️.
    Contribute to open-source projects 📦.
    Explore advanced topics in mobile development 📱 and UI/UX 🎨.

Thank you for visiting my profile! I look forward to connecting with you 😊.`,
 },
  education: [
    {
      id: 1,
      degree: "Master of Computer Applications",
      institution: "Mohan Lal Sukhadiya University",
      year: "2023-2025",
      description: "Specialized in Machine Learning and Distributed Systems"
    },
    {
      id: 2,
      degree: "Bachelor of Computer Applications",
      institution: "Bhupal Nobles' University",
      year: "2020-2023",
      description: "Graduated Magna Cum Laude, Focus on Web Technologies"
    },
    {
      id: 3,
      degree: "Senior Secondary Education",
      institution: "N.I.O.S.",
      year: "2019-2020",
      description: "Graduated Magna Cum Laude, Focus on Web Technologies"
    }
  ],
  certifications: [
    {
      id: 1,
      name: "Web Development Masterclass",
      issuer: "Udemy",
      year: "2023",
      icon: "🌐",
      image: udemy
    },
    {
      id: 2,
      name: "Agile Project Management",
      issuer: "HP Life",
      year: "2024",
      icon: "🗃️",
      image: agile
    },
    {
      id: 3,
      name: "Introduction to Cybersecurity Awareness",
      issuer: "HP Life",
      year: "2024",
      icon: "🔐",
      image: cybersec
    },
    {
      id: 4,
      name: "Cybersecurity for Business",
      issuer: "The Digital Adda",
      year: "2024",
      icon: "🔐",
      image: cybersec2
    },
        {
      id: 5,
      name: "Network Security & Defense Hacking",
      issuer: "The Digital Adda",
      year: "2024",
      icon: "🔐",
      image: networksec
    },
    {
      id: 6,
      name: "Agile with Scrum",
      issuer: "The Digital Adda",
      year: "2024",
      icon: "🗃️",
      image: agile2
    },
    {
      id: 7,
      name: "Data Science",
      issuer: "Pantech E-Learning",
      year: "2023",
      icon: "🔬",
      image: datascience
    },
    {
      id: 8,
      name: "Artificial Intelligence",
      issuer: "Pantech E-Learning",
      year: "2023",
      icon: "🤖",
      image: ai
    },
    {
      id: 9,
      name: "Computer Hardware & Networking",
      issuer: "The Digital Adda",
      year: "2024",
      icon: "🛜",
      image: comphard
    },
    {
      id: 10,
      name: "Internet of Things",
      issuer: "Pantech E-Learning",
      year: "2023",
      icon: "🛜",
      image: iot
    }, 
    {
      id: 11,
      name: "Generative AI",
      issuer: "Pantech E-Learning",
      year: "2024",
      icon: "🤖",
      image: genai
    },
    {
      id: 12,
      name: "Digital Marketing Fundamentals",
      issuer: "India Institute of Digital Education",
      year: "2024",
      icon: "📈",
      image: marketing
    },
    {
      id: 13,
      name: "Digital Marketing Fundamentals",
      issuer: "SimpliLearn|Skill Up ",
      year: "2024",
      icon: "📈",
      image: marketing2
    },
    {
      id: 14,
      name: "Natural Language Processing",
      issuer: "Pantech E-Learning",
      year: "2024",
      icon: "📲",
      image: nlp
    },
    {
      id: 15,
      name: "Data Science and Data Analytics",
      issuer: "Pantech E-Learning",
      year: "2023",
      icon: "🔬",
      image: datasci
    },
    {
      id: 16,
      name: "C Programming",
      issuer: "Pantech E-Learning",
      year: "2023",
      icon: "🧑🏻‍💻",
      image: cprog
    },
    {
      id: 17,
      name: "Web Development Full Stack (Using React JS)",
      issuer: "Pantech E-Learning",
      year: "2024",
      icon: "🧑🏻‍💻",
      image: webdev
    },
    {
      id: 18,
      name: "AWS for Beginners",
      issuer: "Great Learning",
      year: "2023",
      icon: "☁️",
      image: aws
    },
    {
      id: 19,
      name: "Android Application Development",
      issuer: "Great Learning",
      year: "2023",
      icon: "📱",
      image: app
    },
    {
      id: 20,
      name: "Front End Development - HTML",
      issuer: "Great Learning",
      year: "2023",
      icon: "🧑🏻‍💻",
      image: html
    },
    {
      id: 21,
      name: "Front End Development - CSS",
      issuer: "Great Learning",
      year: "2023",
      icon: "🧑🏻‍💻",
      image: css
    },
    {
      id: 22,
      name: "Data Science Foundations",
      issuer: "Great Learning",
      year: "2023",
      icon: "🔬",
      image: datascifoun
    },
    {
      id: 23,
      name: "HTML Introduction",
      issuer: "LearnTube.ai",
      year: "2024",
      icon: "🧑🏻‍💻",
      image: html2
    },
    {
      id: 24,
      name: "Digital Marketing",
      issuer: "Hubspot Academy",
      year: "2024",
      icon: "📈",
      image: digimark
    },
  ],
  projects: [
    {
      id: 1,
      title: "Chrono-Charm",
      description: "An app in React Native that is used for birthday reminder.",
      technologies: ["App"],
      github: "https://github.com/Eshbanoliver",
      demo: "https://github.com/Eshbanoliver"
    },
    {
      id: 2,
      title: "Broken Link Detector",
      description: "Wordpress plugin to detect broken links in a WP website.",
      technologies: ["Wordpress" , "Plugin"],
      github: "https://github.com/Eshbanoliver",
      demo: "https://github.com/Eshbanoliver"
    },
    {
      id: 3,
      title: "Website Core Structure Optimizer",
      description: "Optimizes core functionality of a WP website",
      technologies: ["Wordpress" , "Plugin"],
      github: "https://github.com/Eshbanoliver",
      demo: "https://github.com/Eshbanoliver"
    },
    {
      id: 4,
      title: "Content Freshness Monitor",
      description: "Track the freshness of WP posts. Content update and logs content changes.",
      technologies: ["Wordpress" , "Plugin"],
      github: "https://github.com/Eshbanoliver",
      demo: "https://github.com/Eshbanoliver"
    },
    {
      id: 5,
      title: "Image Optimizer",
      description: "Offers performance optimization suggestions",
      technologies: ["Wordpress" , "Plugin"],
      github: "https://github.com/Eshbanoliver",
      demo: "https://github.com/Eshbanoliver"
    },
    {
      id: 6,
      title: "SEO Content Gap Analyzer",
      description: "Identify keyword and content gaps between your website and competitors",
      technologies: ["Wordpress" , "Plugin"],
      github: "https://github.com/Eshbanoliver",
      demo: "https://github.com/Eshbanoliver"
    },
    {
      id: 7,
      title: "Simple Notepad in Python",
      description: "Simple Notepad (Python) A basic, lightweight notepad application built with Python's Tkinter library",
      technologies: ["Language" , "Python"],
      github: "https://github.com/Eshbanoliver/Simple-Notepad",
      demo: "https://github.com/Eshbanoliver/Simple-Notepad"
    },
    {
      id: 8,
      title: "Calculator in HTML",
      description: "A basic web-based calculator built using HTML, CSS, and JavaScript.",
      technologies: ["Language" , "HTML" , "CSS" , "Javascript"],
      github: "https://github.com/Eshbanoliver/Calculator",
      demo: "https://github.com/Eshbanoliver/Calculator"
    },
    {
      id: 9,
      title: "Portfolio",
      description: "My portfolio showcases a diverse range of projects, highlighting my skills. With a focus on creativity and precision, I bring unique solutions to each challenge.",
      technologies: ["Language" , "HTML" , "CSS" , "Javascript"],
      github: "https://github.com/Eshbanoliver",
      demo: "https://github.com/Eshbanoliver"
    },
    {
      id: 10,
      title: "Logo Designing",
      description: "I design logo for businesses and websites",
      technologies: ["Graphics"],
      github: "",
      demo: ""
    },
    {
      id: 11,
      title: "Image Designing",
      description: "I design images for businesses and websites",
      technologies: ["Graphics"],
      github: "",
      demo: ""
    },
  ],
  contact: {
    email: "olivereshban@gmail.com",
    phone: "+91 9530305588",
    linkedin: "https://www.linkedin.com/in/eshban-oliver-757352372/",
    github: "https://github.com/Eshbanoliver",
    location: "Udaipur, Rajasthan"
  },
  experience: [
    {
      id: 1,
      companyname: "Shapesway Technologies Pvt. Ltd.",
      worktype: "Web Developer Intern",
      duration: "3 Months",
      description: "Developed websites using wordpress, HTML, CSS and made business logos."
    },
  ],
};